import React, { useEffect, useRef, useState } from "react";
import "./AssociationSection.css";
import njWealthLogo from "../../assets/association/Nj-Wealth.png";
// import motilalLogo from "../../assets/association/Motilal-Oswal.png";

const associations = [
  {
    id: "nj",
    name: "NJ Wealth",
    founded: "Est. 2003",
    tagline: "India's Largest Distributor Network",
    logo: njWealthLogo,
    accentColor: "#0e7490",
    stats: [
      { value: "1994", label: "NJ Group Founded" },
      { value: "Pan India", label: "Presence" },
      { value: "#1", label: "Distributor Network" },
    ],
    description:
      "NJ Wealth is one of India's largest networks of financial product distributors, working towards financial inclusion and investor participation in financial markets. Through their flagship NJ E-Wealth Account, they deliver a Simple, 100% Online experience with dedicated mutual fund distributor support.",
    highlight:
      "Trust is at the heart of what we do — putting our customer's interests first.",
  },
  // Motilal Oswal hidden for now — uncomment to show again
  // {
  //   id: "motilal",
  //   name: "Motilal Oswal",
  //   founded: "Est. 1987",
  //   tagline: "Wealth Creation Through Knowledge",
  //   logo: motilalLogo,
  //   accentColor: "#047857",
  //   stats: [
  //     { value: "550+", label: "Cities" },
  //     { value: "2500+", label: "Business Locations" },
  //     { value: "12,500+", label: "Employees" },
  //   ],
  //   description:
  //     "Founded in 1987 as a small sub-broking unit, Motilal Oswal Financial Services has grown into a multi-faceted financial services company. Their expertise spans Wealth Management, Institutional Broking, Investment Banking, Private Equity, Asset Management, and Home Finance.",
  //   highlight:
  //     "A well-diversified financial services company focused on wealth creation through knowledge.",
  // },
];

const AssociationSection = () => {
  const sectionRef = useRef(null);
  const [activeCard, setActiveCard] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.15 },
    );
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="as-section" ref={sectionRef}>
      {/* Background decoration */}
      <div className="as-bg-orb as-bg-orb--1" />
      <div className="as-bg-orb as-bg-orb--2" />

      <div className={`as-inner ${visible ? "as-visible" : ""}`}>
        {/* Header */}
        <div className="as-header">
          <div className="as-badge">
            <span className="as-badge-dot" />
            Our Associations
          </div>
          <h2 className="as-title">
            Backed by <span className="as-title-accent">Industry Leaders</span>
          </h2>
          <p className="as-subtitle">
            We are proudly associated with one of India's most trusted and
            reputable financial institutions, ensuring our clients receive
            world-class expertise and unparalleled access.
          </p>
        </div>

        {/* Cards */}
        <div className="as-cards">
          {associations.map((assoc, i) => (
            <div
              key={assoc.id}
              className={`as-card as-card--${i + 1} ${activeCard === assoc.id ? "as-card--active" : ""}`}
              style={{
                "--accent": assoc.accentColor,
                animationDelay: `${i * 0.18}s`,
              }}
              onMouseEnter={() => setActiveCard(assoc.id)}
              onMouseLeave={() => setActiveCard(null)}
            >
              {/* Top accent bar */}
              <div className="as-card-bar" />

              {/* Logo + Founded */}
              <div className="as-card-top">
                <div className="as-card-logo-wrap">
                  <img
                    src={assoc.logo}
                    alt={assoc.name}
                    className="as-card-logo"
                  />
                </div>
                <div className="as-card-founded">{assoc.founded}</div>
              </div>

              {/* Name + tagline */}
              <div className="as-card-identity">
                <h3 className="as-card-name">{assoc.name}</h3>
                <p className="as-card-tagline">{assoc.tagline}</p>
              </div>

              {/* Divider */}
              <div className="as-card-divider" />

              {/* Stats row */}
              <div className="as-card-stats">
                {assoc.stats.map((stat) => (
                  <div className="as-stat" key={stat.label}>
                    <span className="as-stat-value">{stat.value}</span>
                    <span className="as-stat-label">{stat.label}</span>
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div className="as-card-divider" />

              {/* Description */}
              <p className="as-card-desc">{assoc.description}</p>

              {/* Highlight quote */}
              <div className="as-card-quote">
                <div className="as-card-quote-mark">"</div>
                <p className="as-card-quote-text">{assoc.highlight}</p>
              </div>

              {/* Bottom glow */}
              <div className="as-card-glow" />
            </div>
          ))}
        </div>

        {/* Bottom trust line */}
        <div className="as-trust-row">
          <div className="as-trust-line" />
          <span className="as-trust-text">
            Trusted Partnerships · Regulated · SEBI Compliant
          </span>
          <div className="as-trust-line" />
        </div>
      </div>
    </section>
  );
};

export default AssociationSection;
